/* Offer strip — swipe-only coupon carousel with copy-to-clipboard.
   No dependencies. One instance per .offer-strip on the page. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.offerStripReady === 'true') return;
    root.dataset.offerStripReady = 'true';

    var track = root.querySelector('[data-offer-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-offer-dot]'));
    var counter = root.querySelector('[data-offer-counter]');
    var slides = track ? track.querySelectorAll('.offer-strip__slide') : [];
    if (!track || slides.length === 0) return;

    var total = slides.length;

    function step() {
      var first = track.querySelector('.offer-strip__slide');
      if (!first) return 1;
      var w = first.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return w + gap;
    }

    function currentIndex() {
      var i = Math.round(track.scrollLeft / step());
      return Math.max(0, Math.min(total - 1, i));
    }

    function sync() {
      var i = currentIndex();
      for (var d = 0; d < dots.length; d++) {
        dots[d].setAttribute('aria-current', d === i ? 'true' : 'false');
      }
      if (counter) counter.textContent = (i + 1) + ' of ' + total;
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        track.scrollTo({ left: i * step(), behavior: 'smooth' });
      });
    });

    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });

    window.addEventListener('resize', sync);
    sync();
  }

  function flash(btn) {
    if (btn.dataset.busy === 'true') return;
    btn.dataset.busy = 'true';
    var original = btn.getAttribute('data-label-copy') || btn.textContent;
    btn.textContent = btn.getAttribute('data-label-copied') || 'Copied!';
    btn.classList.add('is-copied');
    setTimeout(function () {
      btn.textContent = original;
      btn.classList.remove('is-copied');
      btn.dataset.busy = 'false';
    }, 2000);
  }

  function legacyCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '0';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    return ok;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-offer-copy]') : null;
    if (!btn) return;
    e.preventDefault();

    var code = btn.getAttribute('data-offer-copy');
    if (!code) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(
        function () { flash(btn); },
        function () { if (legacyCopy(code)) flash(btn); }
      );
    } else if (legacyCopy(code)) {
      flash(btn);
    }
  });

  function boot() {
    document.querySelectorAll('.offer-strip').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init after Shopify section rendering (theme editor / variant swaps)
  document.addEventListener('shopify:section:load', boot);
})();
